export default class Flow {
    constructor(dto) {
        this.id = -1
        this.name = ''
        this.contentTypeIDs = []
        this.defFieldCode = ''
        this.activeNotif = false
        this.notifyByEmail = false

        if (dto) {
            this.id = dto.Id
            this.name = dto.Name
            this.contentTypeIDs = dto.ContentTypeIDs
            this.defFieldCode = dto.DefFieldCode
            this.activeNotif = dto.ActiveNotif
            this.notifyByEmail = dto.NotifyByEmail
        }
    }

    toDto() {
        return {
            Id: this.id,
            Name: this.name,
            ContentTypeIDs: this.contentTypeIDs,
            DefFieldCode: this.defFieldCode,
            ActiveNotif: this.activeNotif,
            NotifyByEmail: this.notifyByEmail,
        }
    }
}
